export default {
    login: 'Login',
    signup: 'Signup',
    menu: 'Menu',
    email: 'Email',
    usernameOrEmail: 'Username or email',
    name: 'Name',
    password: 'Password',
    forgotPasswordTitle: 'Enter your Username or your Email. You will receive an email with a link to reset your password',
    forgotPassword: 'Forgot Password?',
    acceptAgreement: 'By signing up you agree to the sharek omry terms',
    resetPasswordTitle: 'Enter you new password',
    resetPassword: 'Reset Password',
    resetPasswordLinkSent: 'Reset link sent to your email',
    resetPasswordSuccess: 'Password reset successfully, redirecting...',
    changePassword: 'Change password',
    newPassword: 'New password',
    confirmNewPassword: 'Confirm new password',
    oldPassword: 'Old password',
    loginFacebook: 'Login with Facebook',
    loginGoogle: 'Login with Google',
    register: 'Register',
    logout: 'Logout',
    loggingIn: 'Logging you in',
    next: 'Next',
    back: 'Back',
    settings: 'Settings',
    fullList: 'Full list',
    like: 'Like',
    unlike: 'Unlike',
    home: 'Home',
    search: 'Search',
    chat: 'Chat',
    terms: 'Terms and conditions',
    support: 'Contact support',
    membershipUpgrade: 'Upgrade membership',
    listOfLikes: 'List of likes',
    peopleWhoLikeYou: 'People who like you',
    profileViewers: 'Who viewed my profile',
    noViewers: 'You profile has not been visited yet',
    viewersCount: 'Number of profile visitors: ',
    profilesViewed: 'Profiles I viewed',
    noViews: 'You have not visited any profile',
    viewsCount: 'Number of profiles visited: ',
    oppositeLanguage: 'اللغة العربية',
    saveChanges: 'Save changes',
    unblock: 'Unblock',
    block: 'Block',
    report: 'Report',
    more: 'More',
    cancel: 'Cancel',
    notifications: 'Notifications',
    sharekOmry: 'Sharek Omry',
    findMatch: 'Find your match',
    unapprovedUser: 'Your account is being reviewed',
    allRightsReserved: `All rights reserved ${new Date().getFullYear()}`
}
